/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import BankAccountService from "../../service/bank-account-service.js";
import FinancialChannelService from "../../service/financial-channel-service.js";
import BankService from "../../service/bank-service.js";

const bankAccountService = new BankAccountService();
const financialChannelService = new FinancialChannelService();
const bankService = new BankService();

await loadDictionary("bank-account-edit-company-bank-account-window");

function EditCompanyBankAccountWindow({isOpenWindow, onCloseWindow, bankAccountId, reloadList}) {
  const [id, setId] = useState(0);
  const [name, setName] = useState('');
  const [bankId, setBankId] = useState(null);
  const [financialChannelId, setFinancialChannelId] = useState(null);
  const [type, setType] = useState('');
  const [accountNumber, setAccountNumber] = useState();
  const [iban, setIban] = useState();
  const [cardNumber, setCardNumber] = useState('');
  const [accountingNumber, setAccountingNumber] = useState('');
  const [bankOptions, setBankOptions] = useState([]);
  const [financialChannelOptions, setFinancialChannelOptions] = useState([]);

  const handleClose = () => {
    setId(0);
    setName('');
    setBankId(null);
    setFinancialChannelId(null);
    setType('');
    setAccountNumber('');
    setIban('');
    setCardNumber('');
    setAccountingNumber('');

    onCloseWindow();
  };

  const checkIBAN = () => {
    bankAccountService.ibanInfo(iban).then(result => {
      setAccountNumber(result.account_number);
      setName(result.name.trim());
      setBankId(result.bank_id);
      setType(result.type);
    }).catch(error => {
      console.log(error);
    });
  };
  
  const save = () => {
    const bankAccount = {
      id: parseInt(id),
      name: name,
      party_id: null,
      bank_id: parseInt(bankId),
      financial_channel_id: financialChannelId === null ? null : parseInt(financialChannelId),
      type: type,
      account_number: accountNumber,
      iban: iban,
      card_number: cardNumber,
      accounting_number: accountingNumber
    };

    bankAccountService.edit(bankAccount).then(result => {
      if(result) {
        onCloseWindow();
        reloadList();
      }
    }).catch(error => {
      console.error(error);
    });
  }

  useEffect(() => {
    if(!isOpenWindow || !bankAccountId) {
      return;
    }

    bankService.findAll().then(banks => {
      const options = banks.map((bank) => <option key={bank.id} value={bank.id}>{bank.name}</option>);

      setBankOptions(options);
    });

    financialChannelService.findAll().then(channels => {
      const options = channels.map((channel) => <option key={channel.id} value={channel.id}>{channel.name}</option>);
      options.unshift(<option key={0} value={null}>{i18n.t('global.chooseOption')}</option>);

      setFinancialChannelOptions(options);
    });

    bankAccountService.findOne(bankAccountId).then(bankAccount => {
        if(bankAccount) {
            setId(bankAccount.id);
            setName(bankAccount.name);
            setBankId(bankAccount.bank_id);
            setFinancialChannelId(bankAccount.financial_channel_id);
            setType(bankAccount.type);
            setAccountNumber(bankAccount.account_number);
            setIban(bankAccount.iban);
            setCardNumber(bankAccount.card_number);
            setAccountingNumber(bankAccount.accounting_number);
        }
    });
  }, [isOpenWindow, bankAccountId]);

  return (
    <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t("bank-account-edit-company-bank-account-window.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form method="POST" id="EditForm" onSubmit={e => {e.preventDefault(); save()}}>
          <div className="row">
            <Form.Group className="mb-3 col" controlId="">
              <Form.Label>{i18n.t("bank-account-edit-company-bank-account-window.iban")}</Form.Label>
              <div className="row">
                <div className="col pe-1">
                  <Form.Control type="text" dir="ltr" value={iban} onChange={e => {setIban(e.target.value)}}></Form.Control>
                </div>
                <div className="col-auto ps-1">
                  <Button variant="outline-secondary" onClick={checkIBAN}>{i18n.t("bank-account-edit-company-bank-account-window.iban_info")}</Button>
                </div>
              </div>
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="mb-3 col-12" controlId="">
              <Form.Label>{i18n.t("bank-account-edit-company-bank-account-window.name")}</Form.Label>
              <Form.Control type="text" value={name} onChange={e => {setName(e.target.value)}}></Form.Control>
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="mb-3 col-lg-6 col-12" controlId="">
              <Form.Label>{i18n.t("bank-account-edit-company-bank-account-window.bank")}</Form.Label>
              <Form.Select value={bankId} onChange={e => {setBankId(e.target.value)}}>
                {bankOptions}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3 col-lg-6 col-12" controlId="">
              <Form.Label>{i18n.t("bank-account-edit-company-bank-account-window.type")}</Form.Label>
              <Form.Select value={type} onChange={e => {setType(e.target.value)}}>
                <option value={"bank_account"}>{i18n.t("bank-account-edit-company-bank-account-window.types.bank_account")}</option>
                <option value={"bon_card"}>{i18n.t("bank-account-edit-company-bank-account-window.types.bon_card")}</option>
                <option value={"deposit_card"}>{i18n.t("bank-account-edit-company-bank-account-window.types.deposit_card")}</option>
              </Form.Select>
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="mb-3 col-lg-6 col-12" controlId="">
              <Form.Label>{i18n.t("bank-account-edit-company-bank-account-window.account_number")}</Form.Label>
              <Form.Control type="text"  dir="ltr" value={accountNumber} onChange={e => {setAccountNumber(e.target.value)}}></Form.Control>
            </Form.Group>
            <Form.Group className="mb-3 col-lg-6 col-12" controlId="">
              <Form.Label>{i18n.t("bank-account-edit-company-bank-account-window.card_number")}</Form.Label>
              <Form.Control type="text" dir="ltr" value={cardNumber} onChange={e => {setCardNumber(e.target.value)}}></Form.Control>
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="mb-3 col-lg-6 col-12" controlId="">
              <Form.Label>{i18n.t("bank-account-edit-company-bank-account-window.financial_channel")}</Form.Label>
              <Form.Select value={financialChannelId} onChange={e => {setFinancialChannelId(e.target.value)}}>
                {financialChannelOptions}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3 col-lg-6 col-12" controlId="">
              <Form.Label>{i18n.t("bank-account-edit-company-bank-account-window.accounting_number")}</Form.Label>
              <Form.Control type="text" dir="ltr" value={accountingNumber} onChange={e => {setAccountingNumber(e.target.value)}}></Form.Control>
            </Form.Group>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>{i18n.t("bank-account-edit-company-bank-account-window.cancel_button")}</Button>
        <Button variant="primary" type="submit" form="EditForm" >{i18n.t("bank-account-edit-company-bank-account-window.edit_button")}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditCompanyBankAccountWindow;